import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";

const QUERY = gql`
  query dishes($keyword: String) {
    dishes(keyword: $keyword) {
      id
      name
      recipe
    }
  }
`;

const useDishes = (keyword) => {
  const { loading, error, data, refetch } = useQuery(QUERY, {
    variables: { keyword },
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
  });

  return { loading, error, refetch, data: data?.dishes };
};

export default useDishes;
